import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const MaterialToolStaked = ({ data }) => {
  const [chartData, setChartData] = useState({ series: [], labels: [] });

  useEffect(() => {
    const chartMap = new Map();
    data.forEach((item) => {
      if (chartMap.has(item.name)) {
        chartMap.set(item.name, chartMap.get(item.name) + item.count);
      } else {
        chartMap.set(item.name, item.count);
      }
    });

    const names = Array.from(chartMap.keys());
    const counts = Array.from(chartMap.values());

    setChartData({
      series: [
        {
          data: counts,
        },
      ],
      labels: names,
    });
  }, [data]);

  const minYCount = 10;
  const yAxisMax = chartData.labels.length < 5 ? minYCount : undefined;

  const state = {
    options: {
      chart: {
        id: "materialChart",
        type: "bar",
      },
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: true,
          barHeight: "75%",
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ["#fff"],
        },
        formatter: (val, opt) => {
          const name = chartData.labels[opt.dataPointIndex];
          const count = val;
          // return `${name}: ${count}`;
          return count;
        },
      },
      colors: [
        "#6366F1",
        "#06B6D4",
        "#10B981",
        "#F59E0B",
        "#F43F5E",
        "#F97316",
        "#8B5CF6",
      ],
      states: {
        active: {
          allowMultipleDataPointsSelection: true,
          filter: {
            type: "darken",
            value: 1,
          },
        },
      },
      xaxis: {
        categories: chartData.labels,
        labels: {
          style: {
            colors: "#64748B",
          },
        },
      },
      yaxis: {
        max: yAxisMax,
        labels: {
          show: true,
          formatter: (val) => val,
          style: {
            colors: "#64748B",
          },
        },
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const name = w.config.xaxis.categories[dataPointIndex];
          const value = series[seriesIndex][dataPointIndex];
          return `<div class="tooltip-box" style="padding: 8px; background-color: #fff; border: 1px solid #ccc; border-radius: 5px;">
            <strong>${name}:</strong> ${value}
          </div>`;
        },
      },
    },
  };

  return (
    <div className="flex flex-col items-center p-4 space-y-4 w-full bg-white border border-slate-200 shadow-sm rounded-xl">
      <div id="material-chart" className="w-full">
        <ReactApexChart
          options={state.options}
          series={chartData.series}
          type="bar"
          height={400}
        />
      </div>
    </div>
  );
};

export default MaterialToolStaked;
